
import React from 'react';
import AnimatedCard from "@/components/AnimatedCard";

const TrainingHero = () => {
  return (
    <section className="px-6 py-16 bg-gradient-to-b from-[#0c1427] to-[#111832] relative">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/lovable-uploads/Lawyer-Chatbot-Collaboration_remix.jpg"
          alt="Lawyer AI Collaboration"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0c1427]/70 to-[#111832]/70"></div>
      </div>
      
      <div className="container mx-auto max-w-6xl relative z-10">
        <AnimatedCard animation="fade-in">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
              <span className="text-white">Comprehensive </span>
              <span className="text-gradient">AI Training</span>
              <span className="text-white"> for Legal Professionals</span>
            </h1>
            
            <p className="text-lg md:text-xl text-foreground/80 max-w-3xl mx-auto">
              Master the latest AI tools and methodologies designed for legal practice 
              with our premium education programs.
            </p>
          </div>
        </AnimatedCard>

        <div className="mb-14 text-center">
          <AnimatedCard animation="fade-in" delay={200}>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 tracking-tight text-white">
              Continued AI Education for Forward-Thinking Legal Teams
            </h2>
            
            <div className="text-foreground/80 space-y-4 text-left md:text-center max-w-4xl mx-auto">
              <p className="text-base md:text-lg">
                Docket Labs AI education equips legal teams with essential knowledge and skills for today's practice—from basic AI fluency to practical applications and ethical considerations. Designed for all experience levels, we leverage our expertise in legal processes and AI technologies to deliver effective training through self-paced modules, team workshops, and personalized 1-1 sessions that empower everyone from assistants to senior attorneys.
              </p>
            </div>
          </AnimatedCard>
        </div>
      </div>
    </section>
  );
};

export default TrainingHero;
